/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import type Router from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import type FinAgentTypeService from 'embercom/services/fin-agent-type-service';

export default class FinAiAgentSuccessRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;
  @service declare finAgentTypeService: FinAgentTypeService;

  beforeModel(transition: Transition) {
    if (!this.appService.app.canUseFinSuccessAgent) {
      transition.abort();
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
      return;
    }

    this.finAgentTypeService.setCurrentAgentType('success');
  }
}
